import { render } from "./TabelaSlideApresentacao.vue?vue&type=template&id=7af08f8e&scoped=true"
import script from "./TabelaSlideApresentacao.vue?vue&type=script&lang=js"
export * from "./TabelaSlideApresentacao.vue?vue&type=script&lang=js"

import "./TabelaSlideApresentacao.vue?vue&type=style&index=0&id=7af08f8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af08f8e"]])

export default __exports__